import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=97ae29fc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=97ae29fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ae29fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ae29fc')) {
      api.createRecord('97ae29fc', component.options)
    } else {
      api.reload('97ae29fc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=97ae29fc&scoped=true&", function () {
      api.rerender('97ae29fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VQuo3VWz53qf/JS/teamMember.vue"
export default component.exports